'use client';

import dynamic from 'next/dynamic';

const TextEditor = dynamic(() => import('@/components/TextEditor'), {
    ssr: false
});

export default function RichTextEditor(props = {}) {
    return (
        <>
            <TextEditor {...props} />
        </>
    );
};
